import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import NotFound from '../components/NotFound';
import { useScreenQuery } from 'playup-web-core';

import UserOnly from '../User/components/UserOnly';
import CloseAccount from './components/CloseAccount/CloseAccount';
import Limits from './components/Limits/Limits';
import AccountMenu from './components/partials/AccountMenu';
import Profile from './components/Profile/Profile';
import SelfExclusion from './components/SelfExclusion/SelfExclusion';
import TakeBreak from './components/TakeABreak/TakeABreak';
import Transactions from './components/Wallet/Transactions';
import Withdraw from './components/Withdraw/Withdraw';
import appConfig from '../appConfig';
import USWithdraw from './components/USWithdraw/USWithdraw';

const AccountRouteHandler: React.FC = () => {
	const { isSmall } = useScreenQuery();

	const isUS = appConfig.regions.isUS;

	return (
		<UserOnly>
			{!isSmall && <AccountMenu />}
			<Switch>
				<Route exact path="/account">
					{!isSmall && <Redirect to="/account/profile" />}
				</Route>
				<Route path="/account/profile" exact>
					<Profile />
				</Route>
				<Route path="/account/transactions" exact>
					<Transactions />
				</Route>
				<Route path="/account/withdraw" exact>
					{isUS ? <USWithdraw /> : <Withdraw />}
				</Route>
				<Route path="/account/limits" exact>
					<Limits />
				</Route>
				<Route path={['/account/take-a-break', '/account/timeout']} exact>
					<TakeBreak />
				</Route>
				<Route path="/account/close-account" exact>
					<CloseAccount />
				</Route>
				<Route path="/account/self-exclusion" exact>
					<SelfExclusion />
				</Route>
				<Route path="/account/*">
					<NotFound />
				</Route>
			</Switch>
		</UserOnly>
	);
};

export default AccountRouteHandler;
